import { actions } from 'components/handlers/notification/notificationHandlerRedux'

/*
export const infoNotification = store => next => action => {
	next(action);

	if (action.type.startsWith("NOTIFICATION")) return; // ignore notifications

	if (action.type.endsWith("_INFO")) {
		store.dispatch(notificationActions.addInfoToast(action.message))
	}
};*/

export const errorNotification = store => next => action => {
	next(action);

	if (action.type.indexOf("NOTIFICATION") === 0) return; // ignore notifications

	if (action.type.endsWith("_ERROR")) {

		let msg = action.error.message || action.error;

		if (msg.startsWith("permission_denied")) {
			msg = "Sie haben keinen direkten Zugriff auf den Sticker mehr. Bitte benutzen Sie den NFC-, QR- oder Webcode des Stickers.";
		}

		store.dispatch(actions.addErrorToast(msg))
	}
};


// WEBPACK FOOTER //
// ./src/redux/middlewares/notification.js